import { IPersonalizationMethodResponse } from "../../Interfaces";

export function buildEventsExtendedDataParams(personalizationMethodResponse: IPersonalizationMethodResponse): string {
    return JSON.stringify(
        personalizationMethodResponse &&
        personalizationMethodResponse.BranchGroups &&
        personalizationMethodResponse.BranchGroups.reduce(
            (x: number[], b) => b.Id !== 0 ? x.concat(b.Events.map(evt => evt.Id)) : x, []
        )
    ) || "[]";
}